/** ユーザー設定の取得・更新を提供するフック群 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { userSettingsApi } from "../lib/api";
import type { UserSettings } from "../types/user-settings";

const USER_SETTINGS_KEY = ["userSettings"] as const;

export const userSettingsQueryOptions = () => ({
  queryKey: USER_SETTINGS_KEY,
  queryFn: async (): Promise<UserSettings | null> => {
    const res = await userSettingsApi.index.$get();
    if (res.status === 404) return null;
    if (!res.ok) throw new Error("Failed to fetch user settings");
    const json = await res.json();
    return json.data ?? null;
  },
});

export const useUserSettings = () => {
  return useQuery(userSettingsQueryOptions());
};

export const useUpdateUserSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { defaultLabelId: string }) => {
      const res = await userSettingsApi.index.$patch({ json: data });
      if (!res.ok) throw new Error("Failed to update user settings");
      const json = await res.json();
      return json.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: USER_SETTINGS_KEY });
    },
    onError: (err) => {
      toast.error("設定の更新に失敗しました");
    },
  });
};
